import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styled from "styled-components";
import dashboardIcon from '../assets/dashboard/dashboard.png'
import resultsIcon from '../assets/dashboard/result.png'
import leaderboardIcon from '../assets/dashboard/leaderboard.png'
import { useSelector } from "react-redux";


const DashBoardLeftPanel = ({ currentItem, setCurrentItem }) => {
  const navigate = useNavigate();

  const handleItemClick = (item) => {
    setCurrentItem(item);
  };

  return (
    <Box>
      <div
        className={`dashLeftCards navlink ${currentItem === 'dashboard' ? 'active' : ''}`}
        onClick={() => handleItemClick('dashboard')}
      >
        <img src={dashboardIcon} className="icon" />
        <span>Dashboard</span>
      </div>

      <div
        className={`dashLeftCards navlink ${currentItem === 'completedTests' ? 'active' : ''}`}
        onClick={() => handleItemClick('completedTests')}
      >
        <img src={resultsIcon} className="icon" />
        <span>Completed Tests</span>
      </div>

      <div
        className={`dashLeftCards navlink ${currentItem === 'leaderboard' ? 'active' : ''}`}
        onClick={() => handleItemClick('leaderboard')}
      >
        <img src={leaderboardIcon} className="icon" />
        <span>LeaderBoard</span>
      </div>
    </Box>
  );
};

export default DashBoardLeftPanel;


const Box = styled.div`
    height: calc(100vh - 70px);
    width: 18vw;
    box-shadow: 0 3px 4px var(--color);
    padding-top: 30px;
    position: fixed;

  .dashLeftCards {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 1rem;
    margin: 0 1.5vw 1rem 1.5vw;
    padding: 1.5rem 1.5vw;


    .icon {
        width: 2.5rem;
    }
  }
  
  .navlink {
    text-decoration: none;
    color: var(--color);
    font-size: 1.75rem;
    font-weight: 400;
    cursor: pointer;
    
  }
  
  .active {
    background-color: rgb(226, 226, 226);
    color: #121212;
    border-radius: 1rem;
    border-style: none;
  }
  
  @media (max-width: 800px) {
    .dashLeftPanel {
      width: 25vw;
    }
    
  }
  
  @media (max-width: 530px) {
    .dashLeftPanel {
      width: 30vw;
    }
    
  }

`

